import { ErrorService } from "services/error-service";
import { Router } from "aurelia-router";
import { Models } from "models/core";
import { autoinject } from "aurelia-framework";
import { ToastService } from "services/toast-service";
import { EventAggregator } from "aurelia-event-aggregator";
import { NetTypeService } from "services/net-type-service";

@autoinject
export class NetTypeNew {
  private nettype: Models.NetType = new Models.NetType();

  constructor(
    private netTypeService: NetTypeService, 
    private router: Router,
    private toastService: ToastService,
    private errorService: ErrorService,
    private eventAggregator: EventAggregator
  ) {}

  createNetType() {
    this.netTypeService
      .post(this.nettype)
      .then(res => {
        this.eventAggregator.publish("netTypeListReset", 1);
        this.toastService.showSuccess("nettype.created");
        this.router.navigateToRoute("net-type-detail", { Id: res.Id });
      })
      .catch(err => this.errorService.handleError(err));
  }
}
